<template>
  <iframe
    v-if="fileReady"
    :src="`${file.link}#toolbar=0&navpanes=0`"
    :style="`
    width:100%; 
    height:calc(100vh - ${minusHeight}px);`"
    frameborder="0"
    ref="myIframe"
  ></iframe>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";

export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    }
  },
  data() {
    return {
      fileReady: false,
      file: {},
      deletingFileId: 0
    };
  },

  mounted() {
    this.init();
    // Access the iframe element using Vue's ref
    // const iframe = this.$refs.myIframe;

    // // Add event listener to disable right-click
    // //iframe.addEventListener('contextmenu', this.disableRightClick);
    // iframe.onload = () => {
    //   alert('sdf')
    //   iframe.contentWindow.document.addEventListener('contextmenu', this.disableRightClick);
    // };
  },
  // beforeDestroy() {
  //   // Clean up the event listener when the component is destroyed
  //   const iframe = this.$refs.myIframe;
  //   iframe.removeEventListener('contextmenu', this.disableRightClick);
  // },
  methods: {
    // disableRightClick(event) {
    //   event.preventDefault();
    // },
    init() {
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.file = res.data.file;
            this.fileReady = true;
          }
        }
      );
    }
  }
};
</script>
